import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (shiftEmployee: Employee, value: Value) => {
  const employee = employees.get(shiftEmployee.id)

  if (!employee) return

  switch (value) {
    case 'employee_status':
      return employee

    case 'employee_name':
      const u = users.get(employee.attributes.access_id)
      return u
        ? getFullDisplayName({
            firstName: u.attributes.first_name,
            lastName: u.attributes.last_name,
            canSharePreferredName: employee.policy.can('sharePreferredName'),
            preferredName: employee.attributes.preferred_name,
          })
        : undefined

    case 'location':
      return employee.attributes.location_id

    case 'team':
      return employeeTeams(teams, memberships, employee.id).map((team) => team.attributes.id)

    case 'legal_entity':
      return employeeLegalEntityId(employee)
  }
}
